import { render, staticRenderFns } from "./CompanyBankAccount.yaml?vue&type=template&id=5c0bdc3e&component"
import script from "./CompanyBankAccount.yaml?vue&type=script&lang=ts&component"
export * from "./CompanyBankAccount.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports